module.exports = __webpack_public_path__ + "static/media/birthday-party-grid-3.b6c8f5a0.jpg";